var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"info",staticClass:"info"},[_vm._v("Are you doing your BEST?")])}
var staticRenderFns = []

export { render, staticRenderFns }